export default __webpack_public_path__ + "images/Salad.d922c4.jpg";